module.exports = __webpack_public_path__ + "img/payment-method-transfer.f496459f.png";